import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from '@lightspeed/flame/Button';
import Card from '@lightspeed/cirrus-card';
import { Divider } from '@lightspeed/flame/Divider';

const DemoAccount = ({ setupGuide, addInventoryData, processSale, trackPerformance }) => (
  <Fragment>
    <Card className="cr-flex cr-items-center">
      <div>
        <img
          src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/getting-started/demo-customer.jpg"
          srcSet="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/getting-started/demo-customer@2x.jpg 2x, https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/getting-started/demo-customer@3x.jpg 3x"
          style={{ display: 'block' }}
          alt=""
        />
      </div>
      <div className="cr-p-4">
        <h1>Read the Lightspeed Retail Guided Setup</h1>
        <p className="cr-text-s cr-gray-300">
          Set up Lightspeed to work with your business.
          <br />
          We offer FREE onboarding sessions to Lightspeed Retail customers.
        </p>
        <div>
          <Button
            href={setupGuide}
            target="_blank"
            variant="primary"
            fill
            size="large"
            style={{ color: '#fff' }}
          >
            Get started
          </Button>
        </div>
      </div>
    </Card>
    <section className="cr-flex cr-justify-between cr-pv-4">
      <div>
        <h2 className="cr-mb-0">Add inventory to your account</h2>
        <p className="cr-text-s cr-gray-300 cr-mv-0">Manually enter or import your data.</p>
      </div>
      <Button href={addInventoryData} target="_blank" variant="secondary">
        Add data
      </Button>
    </section>
    <div style={{ margin: '0 -1.5rem' }}>
      <Divider />
    </div>
    <section className="cr-flex cr-justify-between cr-pv-4">
      <div>
        <h2 className="cr-mb-0">Process a sale</h2>
        <p className="cr-text-s cr-gray-300 cr-mv-0">Sell the items you added to your account.</p>
      </div>

      <Button href={processSale} target="_blank" variant="secondary">
        Process sale
      </Button>
    </section>
    <div style={{ margin: '0 -1.5rem' }}>
      <Divider />
    </div>
    <section className="cr-flex cr-justify-between cr-pv-4">
      <div>
        <h2 className="cr-mb-0">Track your performance with basic sales reports</h2>
        <p className="cr-text-s cr-gray-300 cr-mv-0">
          For example, the Lines report provides details on individual items.
        </p>
      </div>
      <Button href={trackPerformance} target="_blank" variant="secondary">
        Track sales
      </Button>
    </section>
  </Fragment>
);

DemoAccount.propTypes = {
  setupGuide: PropTypes.string.isRequired,
  addInventoryData: PropTypes.string.isRequired,
  processSale: PropTypes.string.isRequired,
  trackPerformance: PropTypes.string.isRequired,
};

export default DemoAccount;
